import axios from 'axios';
import api from '@/utils/api'
import store from '@/store'

axios.defaults.timeout = 2000000;
axios.defaults.baseURL = '';


//http request 拦截器
axios.interceptors.request.use(
  config => {
    config.data = config.data;
    config.headers = {
      'Content-Type': 'multipart/form-data'
    };
    config.onUploadProgress = function (progressEvent) {
      let complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
      store.dispatch('changeComplete', complete)
    }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);


//http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.sta == -500) {
      if(!wemeet.app.isTMWebview()) localStorage.removeItem("token");
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(api.baseUrl + url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

function post(url, data = {}, config) {
  return new Promise((resolve, reject) => {
    axios.post(api.baseUrl + url, data, config)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}


export default {
  get,
  post
}



// WEBPACK FOOTER //
// ./src/utils/picOnly.js